import createStore from '@utilities/store';

interface SmartSubscriptionInterface {
    projectPhaseId?: string;
    districtId?: string;
    title?: string;
    area?: string;
    name?: string;
}

export interface SmartSubscriptionState {
    project: SmartSubscriptionInterface;
}

const UPDATE_PROJECT = 'updateProject';

const initialState: SmartSubscriptionState = {
    project: {
        projectPhaseId: undefined,
        districtId: undefined,
        title: undefined,
        area: undefined,
        name: undefined,
    },
};

const actions = {
    [UPDATE_PROJECT]: (state: SmartSubscriptionState, project: SmartSubscriptionInterface) => {
        state.project = project;
        return state;
    },
};

export const smartSubscriptionStore = createStore<SmartSubscriptionState>({
    initialState,
    actions,
});

export const updateSmartSubscriptionProject = (project: SmartSubscriptionInterface) => {
    smartSubscriptionStore.dispatch(UPDATE_PROJECT, project);
};

export const getSmartSubscriptionProject = () => smartSubscriptionStore.getState().project;
